import { IModel } from "@/@types/models/model";

import { coreFields} from "./helpers/coreFields";
import { commonFields } from "./helpers/commonFields";

/*
 id               INTEGER      NOT NULL,
  title            TEXT         NOT NULL,
  procedure_name   TEXT         NOT NULL,
  display_ttoken   TEXT         NOT NULL,
  description      TEXT,
  severity         INTEGER      NOT NULL,
  active           BOOLEAN      NOT NULL DEFAULT TRUE,
  sortorder        INTEGER,
  created_on       TIMESTAMPTZ  NOT NULL DEFAULT CURRENT_TIMESTAMP
*/

const QCFunction: IModel = {
  title: "Photos 360",
  apiPath: "qc/functions/",
  forms: {
    default: {
      fields: ["id"]
    }
  },
  listViews: {
    default: {
      fields: ["id"]
    }
  },
  fields: [
    coreFields.id,
    {
      title: "File name",
      source: "title",
      ttoken: "qc.title",
      type: "text",
      readonly: true
    },
    {
      title: "Procedure name",
      source: "procedure_name",
      ttoken: "qc.procedure_name",
      type: "text",
      readonly: true
    },
    {
      title: "Description",
      source: "description",
      ttoken: "qc.description",
      type: "text",
      readonly: true
    },
    {
      title: "Severity",
      source: "severity",
      ttoken: "qc.severity",
      type: "numeric",
      readonly: true
    },
     {
      title: "Sort order",
      source: "sortorder",
      ttoken: "qc.sortorder",
      type: "numeric",
      readonly: true
    },
    coreFields.active,
    coreFields.created_on
  ]
}

export default QCFunction;
